import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { setActivityCallback } from '../utils/fetchWithActivity';

interface ActivityTrackerProps {
  children: React.ReactNode;
}

export const ActivityTracker: React.FC<ActivityTrackerProps> = ({ children }) => {
  const { resetActivityTimer } = useAuth();

  useEffect(() => {
    // Set the global activity callback
    setActivityCallback(resetActivityTimer);
  }, [resetActivityTimer]);

  return <>{children}</>;
};